import { NamedSystemBetTypes } from "../../../types";
export const isSystemBet = (betType) => {
    return betType in NamedSystemBetTypes || betType.includes("System");
};
//# sourceMappingURL=isSystemBet.js.map